import { RecCardType } from '@/types/page'

export type CardListType = {
  cardviews: RecCardType[]
  header: string
  tag: string
  href?: string
  more?: string
  url?: string
}

export type CardListsStateType = {
  cardLists: CardListType[]
  initCardLists: CardListType[]
  loading: boolean
  updatedAt: number
}

export const initialCardListsState: CardListsStateType = {
  cardLists: [],
  initCardLists: [],
  loading: false,
  updatedAt: 0,
}
